import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from "moment"
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.css']
})
export class StudentProfileComponent implements OnInit {

  constructor(private studentPortalService: StudentPortalService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }



  isCollapsed = false;
  isCollapsed1 = true;
  isCollapsed4 = true;
  isCollapsed15 = true;
  isCollapsed16 = true;
  isCollapsed17 = true;
  StudentView:any;
  ListSpecialAchievement:any;
  ListCounselling:any;
  ListDesciplinary:any;
  StudentEnquiryModel:any;
  StudentDocumentList:any;
  CourseList:any;
  BrothersAndSistersList:any;
  GetStudentDetailsByStudentID_StudentPortal  () {

     this.studentPortalService.GetStudentDetailsByStudentID_StudentPortal().subscribe((response: any) => {
          this.StudentView = response.StudentViewList;
          this.ListSpecialAchievement = response.StudentViewList.SpecialAchievementList;
          this.ListCounselling = response.StudentViewList.CounsellingList;
          this.ListDesciplinary = response.StudentViewList.DesciplinaryList;
          this.StudentEnquiryModel = this.StudentView.StudentDetails;
          this.StudentEnquiryModel.VisaExpiryDate = moment(this.StudentView.StudentDetails.VisaExpiryDate).format('DD-MMM-YYYY');
          this.StudentEnquiryModel.PassportExpiryDate = moment(this.StudentView.StudentDetails.PassportExpiryDate).format('DD-MMM-YYYY');
          this.StudentEnquiryModel.DOB = moment(this.StudentView.StudentDetails.DOB).format('DD-MMM-YYYY');
         
          this.StudentEnquiryModel.EmailID = this.StudentView.StudentDetails.EmailID;
          this.StudentEnquiryModel.HouseName = this.StudentView.StudentDetails.HouseName;
          // this.GetFeeInstallmentComponent();
         
          this.StudentDocumentList = this.StudentView.StudentDocumentList;
          this.CourseList = this.StudentView.CourseDetailsList;
          this.BrothersAndSistersList = this.StudentView.StudentSeblingList;
          if (this.StudentView.ParentsDetails != null) {
              this.StudentEnquiryModel.FatherName = this.StudentView.ParentsDetails.FatherName;
              this.StudentEnquiryModel.FatherCompanyAddress = this.StudentView.ParentsDetails.FatherCompanyAddress;
              this.StudentEnquiryModel.FatherNationality = this.StudentView.ParentsDetails.FatherNationality;
              this.StudentEnquiryModel.MotherNationality = this.StudentView.ParentsDetails.MotherNationality;
              this.StudentEnquiryModel.FatherCompanyName = this.StudentView.ParentsDetails.FatherCompanyName;
              this.StudentEnquiryModel.FatherContactCell = this.StudentView.ParentsDetails.FatherContactCell;
              this.StudentEnquiryModel.FatherContactHome = this.StudentView.ParentsDetails.FatherContactHome;
              this.StudentEnquiryModel.FatherContactWork = this.StudentView.ParentsDetails.FatherContactWork;
              this.StudentEnquiryModel.FatherDesignation = this.StudentView.ParentsDetails.FatherDesignation;
              this.StudentEnquiryModel.FatherOccupation = this.StudentView.ParentsDetails.FatherOccupation;
              this.StudentEnquiryModel.FatherOfficeEmailID = this.StudentView.ParentsDetails.FatherOfficeEmailID;
              this.StudentEnquiryModel.FatherPassportExpiryDate = moment(this.StudentView.ParentsDetails.FatherPassportExpiryDate).format('DD-MMM-YYYY');
              this.StudentEnquiryModel.FatherPassportNo = this.StudentView.ParentsDetails.FatherPassportNo;
              this.StudentEnquiryModel.FatherPermanentAddress = this.StudentView.ParentsDetails.FatherPermanentAddress;
              this.StudentEnquiryModel.FatherPersonalMailID = this.StudentView.ParentsDetails.FatherPersonalMailID;
              this.StudentEnquiryModel.FatherPhotoPath = this.StudentView.ParentsDetails.FatherPhotoPath;
              this.StudentEnquiryModel.FatherPresentAddress = this.StudentView.ParentsDetails.FatherPresentAddress;
              this.StudentEnquiryModel.FatherVisaExpiryDate = moment(this.StudentView.ParentsDetails.FatherVisaExpiryDate).format('DD-MMM-YYYY');
              this.StudentEnquiryModel.FatherVisaNo = this.StudentView.ParentsDetails.FatherVisaNo;
              this.StudentEnquiryModel.MotherName = this.StudentView.ParentsDetails.MotherName;
              this.StudentEnquiryModel.MotherCompanyAddress = this.StudentView.ParentsDetails.MotherCompanyAddress;
              this.StudentEnquiryModel.MotherCompanyName = this.StudentView.ParentsDetails.MotherCompanyName;
              this.StudentEnquiryModel.MotherContactCell = this.StudentView.ParentsDetails.MotherContactCell;
              this.StudentEnquiryModel.MotherContactHome = this.StudentView.ParentsDetails.MotherContactHome;
              this.StudentEnquiryModel.MotherContactWork = this.StudentView.ParentsDetails.MotherContactWork;
              this.StudentEnquiryModel.MotherDesignation = this.StudentView.ParentsDetails.MotherDesignation;
              this.StudentEnquiryModel.MotherOccupation = this.StudentView.ParentsDetails.MotherOccupation;
              this.StudentEnquiryModel.MotherOfficeEmailID = this.StudentView.ParentsDetails.MotherOfficeEmailID;
              this.StudentEnquiryModel.MotherPassportExpiryDate = moment(this.StudentView.ParentsDetails.MotherPassportExpiryDate).format('DD-MMM-YYYY');
              this.StudentEnquiryModel.MotherPassportNo = this.StudentView.ParentsDetails.MotherPassportNo;
              this.StudentEnquiryModel.MotherPermanentAddress = this.StudentView.ParentsDetails.MotherPermanentAddress;
              this.StudentEnquiryModel.MotherPersonalMailID = this.StudentView.ParentsDetails.MotherPersonalMailID;
              this.StudentEnquiryModel.MotherPhotoPath = this.StudentView.ParentsDetails.MotherPhotoPath;
              this.StudentEnquiryModel.MotherPresentAddress = this.StudentView.ParentsDetails.MotherPresentAddress;
              this.StudentEnquiryModel.MotherVisaExpiryDate = moment(this.StudentView.ParentsDetails.MotherVisaExpiryDate).format('DD-MMM-YYYY');
              this.StudentEnquiryModel.MotherVisaNo = this.StudentView.ParentsDetails.MotherVisaNo;
              this.StudentEnquiryModel.FatherPhotoPath = this.StudentView.ParentsDetails.FatherPhotoPath;
              this.StudentEnquiryModel.MotherPhotoPath = this.StudentView.ParentsDetails.MotherPhotoPath;
          }
      });

  }


  ngOnInit() {
    this.GetStudentDetailsByStudentID_StudentPortal();
  }

}
